import React, { Component } from "react";
import { connect } from "react-redux";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class TotalCharge extends Component {
  render() {
    const { language, settings, distributor } = this.props;
    const { custom_texts } = settings;
    const currency =
      language == "english"
        ? settings.currency_english
        : settings.currency_local;

    let height = 110;

    let vat = distributor.vat_rate
      ? parseFloat(
          parseFloat(this.props.total) * parseFloat(distributor.vat_rate)
        ).toFixed(settings.currency_decimals)
      : 0;

    let discountt = this.props.discountTotal
      ? parseFloat(this.props.discountTotal).toFixed(settings.currency_decimals)
      : parseFloat(0).toFixed(settings.currency_decimals);
    if (vat) height += 25;

    let subTotal = this.props.subtotal;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        className="py-2 border-top totalCharge-english"
        style={{
          position: "fixed",
          width: "100%",
          bottom: 60,
          backgroundColor: "white",
          height: height,
          zIndex: 1,
        }}
      >
        <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
          <div className="col">
            <p
              className={"mb-0 ".concat(
                language == "english" ? "float-left ml-4" : "float-right mr-4"
              )}
              style={{ fontSize: 16 }}
            >
              {language == "english" ? "Subtotal" : "الإجمالي"}
            </p>
          </div>

          <div className="col">
            <p
              className={"mb-0 ".concat(
                language == "english" ? "float-right mr-4" : "float-left ml-4"
              )}
              style={{ fontSize: 16 }}
            >
              <span
                className={currencyIcon}
              >
                {subTotal.toFixed(settings.currency_decimals)} {currency}
              </span>
            </p>
          </div>
        </div>

        <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
          <div
            className="col"
            style={{
              display: "flex",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <p
              className={"mb-0 ".concat(
                language == "english" ? "float-left ml-4" : "float-right mr-4"
              )}
              style={{
                fontSize: 16,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {language == "english"
                ? custom_texts.delivery_fee_text
                : custom_texts.delivery_fee_text_ar}
            </p>
          </div>

          <div className="col">
            <p
              className={"mb-0 "
                .concat(
                  language == "english" ? "float-right mr-4" : "float-left ml-4"
                )
                .concat(currencyIcon)}
              style={{ fontSize: 16 }}
            >
              {(this.props.applied_promo &&
                this.props.applied_promo.discount_type === "delivery") ||
              this.props.discounts.delivery.length ? (
                <span>
                  {(0.0).toFixed(settings.currency_decimals)} {currency}
                </span>
              ) : (
                <span>
                  {this.props.deliveryPrice.toFixed(settings.currency_decimals)}{" "}
                  {currency}
                </span>
              )}
            </p>
          </div>
        </div>

        <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
          <div
            className="col"
            style={{
              display: "flex",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <p
              className={"mb-0 ".concat(
                language == "english" ? "float-left ml-4" : "float-right mr-4"
              )}
              style={{
                fontSize: 16,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {language == "english" ? "Discount" : "الخصم"}
            </p>
          </div>

          <div className="col">
            <p
              className={"mb-0 "
                .concat(
                  language == "english" ? "float-right mr-4" : "float-left ml-4"
                )
                .concat(currencyIcon)}
              style={{ fontSize: 16 }}
            >
              <span>
                {`${discountt}
                ${currency}`}
              </span>
            </p>
          </div>
        </div>

        {!!vat && (
          <div className="row mb-1" dir={language == "english" ? "ltr" : "rtl"}>
            <div className="col">
              <p
                className={
                  language == "english" ? "float-left ml-4" : "float-right mr-4"
                }
                style={{ fontSize: 16 }}
              >
                {language == "english" ? "VAT" : "ضرائب"}
              </p>
            </div>
            <div className="col">
              <p
                className={`${
                  language == "english" ? "float-right mr-4" : "float-left ml-4"
                } ${currencyIcon}`}
                style={{ fontSize: 16 }}
              >
                {`${vat}
                ${currency}`}
              </p>
            </div>
          </div>
        )}

        <div className="row" dir={language == "english" ? "ltr" : "rtl"}>
          <div className="col">
            <p
              className={
                language == "english" ? "float-left ml-4" : "float-right mr-4"
              }
              style={{ fontSize: 16, fontWeight: 600 }}
            >
              {language == "english" ? "Total" : "المجموع"}
            </p>
          </div>
          <div className="col">
            <p
              className={`${
                language == "english" ? "float-right mr-4" : "float-left ml-4"
              } ${currencyIcon}`}
              style={{ fontSize: 16, fontWeight: 600 }}
            >
              {parseFloat(
                parseFloat(this.props.total) +
                  parseFloat(vat) -
                  parseFloat(discountt)
              ).toFixed(settings.currency_decimals)}{" "}
              {currency}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    applied_promo: state.cart.promos,
    discounts: state.cart.discounts,
    settings: state.store.store.settings,
    discounts: state.cart.discounts,
  };
};

export default connect(mapStateToProps)(TotalCharge);
